let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("890pK")).then(() => parcelRequire('a2EQ7'));